<template>
  <div>
    <br/>
    <h5 class="pageTitle">Cours d'ornithologie offerts par le COQ</h5>
    <table id="professeur">
      <tr>
        <td style="padding-bottom:50px"><img :src="require('../../../public/images/hibou_livre.png')" alt=""/></td>
        <!-- Le padding sert à éloigner les onglets -->
        <td>
          <table>
            <tr>
              <td><h1 class="titre">Le Club offre deux catégories de cours portant sur l'ornithologie:</h1></td>
            </tr>
            <tr>
              <td>
                <table>
                  <tr>
                    <td><img :src="require('../../../public/images/fleche_boulet.png')" alt=""/></td>
                    <td><h1>des cours <span style="color:#b1661b;">d'initiation;</span></h1></td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tr>
                    <td><img :src="require('../../../public/images/fleche_boulet.png')" alt=""/></td>
                    <td><h1>des cours <span style="color:#b1661b;">spécialisés.</span></h1></td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>

    <!-- Fin de 'professeur' -->

    <div id="intro">
      <h2 class="pageSubtitle2">
        Cours spécialisés - approfondissez vos connaissance
      </h2>
      <p>
        Les cours <span style="color:#b1661b; font-weight: bold;">spécialisés</span>
        vont vous permettre d'approfondir votre connaissance d'un groupe d'oiseaux.
        <br/>
        Le club offre des cours sur les groupes suivants : les
        <span style="color:#b1661b;font-weight: bold;">Parulines</span>, les
        <span style="color:#b1661b;font-weight: bold;">Parulines d'automne</span>, les
        <span style="color:#b1661b;font-weight: bold;">Limicoles</span>, les
        <span style="color:#b1661b;font-weight: bold;">Bruants</span>, les
        <span style="color:#b1661b;font-weight: bold;">Rapaces</span>, les
        <span style="color:#b1661b;font-weight: bold;">Laridés</span> et la
        <span style="color:#b1661b;font-weight: bold;">migration des oiseaux</span>.
      </p>
      <p>
        Ces ateliers sont donnés par des membres qui ont atteint une grande
        expérience dans ces groupes. Dans le cadre de chacun de ces cours, des
        sorties sont prévues sur le terrain afin de perfectionner les techniques
        apprises.
      </p>
      <p>
        Vous y apprendrez des trucs simples et efficaces dans une ambiance
        dynamique et très animée!
      </p>
      <p>
        Notez qu'il n'est pas nécessaire de s'être inscrit aux cours
        d'initiation pour y participer.<br/><br/>
        De plus, il peut arriver qu'un cours ne soit pas donné, faute d'un
        nombre suffisant d'inscriptions. Consultez l'onglet
        <span style="color:#b1661b;font-weight: bold;">Cours en réserve</span>
        afin de vous donner une idée du contenu de ces cours, de même que de
        ceux qui ont déjà été donnés.
      </p>
      <br/>
    </div>

    <!-- Onglets -->
    <div id="barreNavigation">
      <div id="liste">
        <ul>
          <li>
            <router-link :to="{ name: 'CoursInitPage' }">Cours d'initiation</router-link>
          </li>
          <li>
            <a href="#" id="ongletActif">Cours spécialisés</a>
          </li>
        </ul>
      </div>
    </div>
    <!-- Fin des onglets -->

    <div v-for="_class in cours" :key="_class._id">
      <class :_class="_class"/>
      <div class="separateur"></div>
    </div>
    <div v-if="cours.length === 0">
      <br/>
      <p>Il n'y a pas de cours spécialisé pour le moment.</p>
    </div>
  </div>
</template>

<script>
  import Class from '../../components/Cours/Cours';
  import CoursMixin from '@/pages/Cours/Cours.mixin';

  export default {
    name: 'CoursSpecialises',
    components: { Class },
    mixins: [ CoursMixin ],
    data() {
      return {
        classType: 'cours_specialises'
      };
    }
  };
</script>

<style scoped>
li {
  margin-bottom: 0 !important;
}

p a {
  font-size: 12px !important;
}
</style>
